// SVGIcons.js
import React from "react";

export const SVGIcons = {
  Summary: ({ primaryColor = "#000", secondaryColor = "#fff", size = 24 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill={secondaryColor} />
      <g clip-path="url(#clip0_79_3067)">
        <path
          d="M14.9751 24.1249C12.7626 24.1249 10.5501 24.0999 8.33762 24.1374C7.42512 24.15 6.90012 23.5125 7.01262 22.6375C7.17512 21.3375 7.55012 20.1625 8.36262 19.125C9.35012 17.85 10.6501 17.075 12.2251 16.8125C12.7876 16.7125 13.3751 16.7 13.9501 16.6875C14.8251 16.6625 15.7001 16.6625 16.5751 16.6875C19.0751 16.7375 20.9876 17.8125 22.2376 20C22.7751 20.9375 22.9876 21.9625 23.0251 23.025C23.0376 23.6625 22.5501 24.1249 21.9001 24.1249C19.6001 24.1249 17.3001 24.1249 15.0001 24.1249H14.9751Z"
          fill={primaryColor}
        />
        <path
          d="M19.5501 10.4375C19.5501 12.9625 17.5251 14.9875 15.0001 14.9875C12.5626 14.9875 10.4251 13.05 10.4376 10.4125C10.4501 7.72505 12.6376 5.86255 15.0001 5.86255C17.6126 5.86255 19.6376 8.07505 19.5376 10.4375H19.5501Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_79_3067">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(2.5 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Experience: ({
    primaryColor = "#000",
    secondaryColor = "#fff",
    size = 24,
  }) => (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="15" fill={secondaryColor} />
        <g clip-path="url(#clip0_79_3077)">
          <path
            d="M15.5101 14.99C13.9701 14.99 12.4301 14.99 10.8901 14.99C10.6601 14.99 10.5801 14.92 10.5801 14.69C10.5801 12.38 10.5701 10.07 10.5801 7.76001C10.5901 6.19001 11.6701 5.15001 13.2301 5.14001C14.7501 5.14001 16.2701 5.14001 17.7901 5.14001C19.3301 5.14001 20.3901 6.19001 20.4001 7.73001C20.4101 10.05 20.4001 12.37 20.4001 14.69C20.4001 14.92 20.3401 14.99 20.1101 14.98C18.5701 14.97 17.0301 14.98 15.4901 14.98L15.5101 14.99Z"
            fill={primaryColor}
          />
          <path
            d="M15.49 16.25C17.21 16.25 18.94 16.25 20.66 16.25C21.22 16.25 21.77 16.31 22.09 16.85C22.36 17.32 22.63 17.8 22.8 18.31C23.1 19.18 22.49 19.92 21.51 19.93C20.03 19.94 18.55 19.94 17.08 19.93C16.8 19.93 16.71 20 16.72 20.29C16.74 20.9 16.73 21.52 16.72 22.14C16.72 22.36 16.79 22.42 17 22.42C17.43 22.42 17.87 22.42 18.28 22.49C18.91 22.61 19.23 23.14 19.17 23.8C19.11 24.4 18.63 24.85 18.01 24.85C16.38 24.85 14.75 24.83 13.12 24.86C12.34 24.88 11.86 24.27 11.85 23.69C11.85 22.94 12.3 22.45 13.08 22.41C13.4 22.39 13.72 22.4 14.03 22.41C14.23 22.41 14.31 22.34 14.31 22.14C14.31 21.49 14.31 20.85 14.31 20.2C14.31 19.95 14.17 19.93 13.97 19.93C12.46 19.93 10.95 19.93 9.43998 19.93C8.69998 19.93 8.19998 19.47 8.12998 18.77C8.12998 18.71 8.10998 18.64 8.12998 18.59C8.33998 17.87 8.62998 17.18 9.13998 16.62C9.27998 16.46 9.53998 16.38 9.75998 16.32C9.97998 16.26 10.23 16.26 10.46 16.26C12.13 16.26 13.81 16.26 15.48 16.26L15.49 16.25Z"
            fill={primaryColor}
          />
          <path
            d="M21.71 12.45C21.71 12.03 21.71 11.61 21.71 11.19C21.71 10.59 22.22 10.13 22.86 10.11C23.45 10.09 24.05 10.46 24.08 11.08C24.12 12.02 24.1 12.96 24.11 13.9C24.11 13.94 24.09 13.98 24.08 14.02C23.93 14.7 23.48 15.03 22.77 14.98C22.2 14.94 21.77 14.51 21.73 13.89C21.7 13.41 21.73 12.93 21.73 12.45H21.71Z"
            fill={primaryColor}
          />
          <path
            d="M9.32005 12.54C9.32005 12.94 9.32005 13.34 9.32005 13.74C9.31005 14.47 8.85005 14.97 8.19005 14.98C7.43005 15 6.94005 14.57 6.91005 13.8C6.88005 12.91 6.89005 12.02 6.91005 11.13C6.93005 10.53 7.47005 10.1 8.11005 10.1C8.74005 10.1 9.25005 10.56 9.30005 11.15C9.30005 11.18 9.30005 11.21 9.30005 11.24C9.30005 11.67 9.30005 12.1 9.30005 12.53L9.32005 12.54Z"
            fill={primaryColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_79_3077">
            <rect
              width="25"
              height="25"
              fill="white"
              transform="translate(3 2.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
  Achievements: ({
    primaryColor = "#000",
    secondaryColor = "#fff",
    size = 24,
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill={secondaryColor} />
      <path
        d="M15.8115 10.7268C16.8248 8.90902 17.3315 8.00012 18.089 8.00012C18.8465 8.00012 19.3531 8.90902 20.3665 10.7268L20.6286 11.1971C20.9166 11.7137 21.0605 11.972 21.285 12.1424C21.5095 12.3128 21.7891 12.376 22.3483 12.5026L22.8574 12.6177C24.8251 13.063 25.809 13.2856 26.0431 14.0383C26.2771 14.791 25.6064 15.5754 24.2649 17.1441L23.9179 17.5499C23.5366 17.9957 23.346 18.2186 23.2603 18.4943C23.1746 18.77 23.2034 19.0674 23.261 19.6622L23.3135 20.2036C23.5163 22.2966 23.6177 23.3431 23.0049 23.8083C22.392 24.2735 21.4708 23.8494 19.6285 23.0011L19.1518 22.7816C18.6282 22.5405 18.3665 22.42 18.089 22.42C17.8115 22.42 17.5497 22.5405 17.0262 22.7816L16.5495 23.0011C14.7071 23.8494 13.7859 24.2735 13.1731 23.8083C12.5603 23.3431 12.6617 22.2966 12.8645 20.2036L12.917 19.6622C12.9746 19.0674 13.0034 18.77 12.9177 18.4943C12.8319 18.2186 12.6413 17.9957 12.2601 17.5499L11.9131 17.1441C10.5716 15.5754 9.90085 14.791 10.1349 14.0383C10.369 13.2856 11.3529 13.063 13.3206 12.6177L13.8297 12.5026C14.3889 12.376 14.6685 12.3128 14.8929 12.1424C15.1174 11.972 15.2614 11.7137 15.5494 11.1971L15.8115 10.7268Z"
        fill={primaryColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.7455 9.20241C10.7639 8.63138 8.63821 8.933 6.58729 10.1341L6.37913 10.256C6.0217 10.4653 5.56226 10.3452 5.35293 9.9878C5.14361 9.63037 5.26368 9.17092 5.62111 8.9616L5.82927 8.8397C8.18969 7.45737 10.737 7.0626 13.1608 7.76106L13.3687 7.82096C13.7667 7.93566 13.9964 8.35129 13.8817 8.74931C13.767 9.14733 13.3514 9.37701 12.9534 9.26231L12.7455 9.20241ZM8.83628 13.9365C8.87144 14.3492 8.56537 14.7123 8.15265 14.7474C7.99949 14.7605 7.88206 14.7679 7.78365 14.7742C7.60627 14.7854 7.49069 14.7928 7.33902 14.8219C7.14253 14.8596 6.8874 14.9394 6.4244 15.1709C6.05391 15.3562 5.60341 15.206 5.41817 14.8355C5.23293 14.465 5.38309 14.0145 5.75358 13.8293C6.29057 13.5608 6.68032 13.4209 7.05627 13.3488C7.30317 13.3014 7.55804 13.2848 7.78724 13.2698C7.87053 13.2644 7.95043 13.2592 8.02533 13.2528C8.43804 13.2177 8.80112 13.5237 8.83628 13.9365ZM9.91788 19.8561C8.73392 19.5786 7.48653 19.8538 6.55316 20.5892C6.22781 20.8456 5.75624 20.7896 5.49988 20.4643C5.24353 20.1389 5.29946 19.6674 5.62482 19.411C6.92261 18.3884 8.63911 18.0158 10.2601 18.3956C10.6634 18.4901 10.9137 18.8937 10.8192 19.297C10.7247 19.7003 10.3212 19.9506 9.91788 19.8561Z"
        fill={primaryColor}
      />
    </svg>
  ),
  Education: ({
    primaryColor = "#000",
    secondaryColor = "#fff",
    size = 24,
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill={secondaryColor} />
      <g clip-path="url(#clip0_79_3116)">
        <path
          d="M10.5399 10.7201C10.5399 10.4301 10.5399 10.1401 10.5399 9.86012C10.5399 9.71011 10.4899 9.61011 10.3299 9.58011C9.9299 9.50011 9.5299 9.43011 9.1299 9.35011C8.9199 9.31011 8.8299 9.37011 8.8299 9.60011C8.8399 10.2101 8.7999 10.8301 8.8499 11.4401C8.8799 11.9001 9.0099 12.3501 9.0999 12.8101C9.1899 13.2601 9.2899 13.7001 9.3799 14.1401C9.4699 14.6001 9.2199 15.0101 8.6899 14.9701C8.4299 14.9501 8.1699 14.9701 7.9099 14.9701C7.3799 14.9701 7.1299 14.6501 7.2299 14.1401C7.3699 13.4801 7.5099 12.8201 7.6299 12.1501C7.6999 11.7501 7.7299 11.3401 7.7399 10.9401C7.7599 10.4001 7.7499 9.86012 7.7399 9.32012C7.7399 9.22012 7.6899 9.07011 7.6099 9.02011C7.2699 8.79011 7.1499 8.49012 7.2299 8.11012C7.3099 7.72012 7.6299 7.56011 7.9799 7.49011C10.1899 7.04011 12.3999 6.61011 14.5999 6.16011C15.1499 6.05011 15.6699 6.22011 16.1899 6.33011C17.7599 6.63011 19.3199 6.95011 20.8799 7.27011C21.3199 7.36011 21.7599 7.44011 22.1799 7.56011C22.5899 7.68011 22.7999 8.00011 22.7699 8.37011C22.7299 8.77011 22.4399 9.08012 22.0499 9.15012C21.2699 9.30012 20.4899 9.45011 19.6999 9.60011C19.4999 9.64011 19.4199 9.72011 19.4199 9.93011C19.4199 10.7101 19.4399 11.4901 19.3599 12.2701C19.1999 13.9201 18.0599 15.3101 16.4999 15.8501C15.7699 16.1001 15.0299 16.2001 14.2799 16.0601C13.2899 15.8901 12.4099 15.4701 11.7199 14.7101C10.8699 13.7901 10.5699 12.6801 10.5299 11.4701C10.5299 11.2301 10.5299 10.9901 10.5299 10.7501L10.5399 10.7201Z"
          fill={primaryColor}
        />
        <path
          d="M14.9998 23.8901C12.8098 23.8901 10.6098 23.8901 8.41985 23.8901C7.60985 23.8901 7.17985 23.4501 7.21985 22.6401C7.33985 20.4901 8.34985 18.9001 10.2298 17.8601C10.4998 17.7101 10.7898 17.6001 11.0798 17.5101C11.5398 17.3701 11.8998 17.5501 12.2198 17.8901C12.9398 18.6701 13.6598 19.4401 14.3898 20.2101C14.8598 20.7101 15.1398 20.7101 15.6098 20.2101C16.3198 19.4501 17.0298 18.6901 17.7398 17.9301C18.2298 17.4101 18.5098 17.3401 19.1698 17.6001C20.7798 18.2101 21.8698 19.3401 22.4398 20.9501C22.6398 21.5201 22.7098 22.1601 22.7598 22.7701C22.8098 23.3601 22.3098 23.8901 21.6698 23.8801C19.4398 23.8601 17.2098 23.8801 14.9798 23.8801L14.9998 23.8901Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_79_3116">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(2.5 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Languages: ({
    primaryColor = "#000",
    secondaryColor = "#fff",
    size = 24,
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill={secondaryColor} />
      <g clip-path="url(#clip0_79_2804)">
        <path
          d="M14.9898 20.8099C12.4598 20.8099 9.93984 20.8099 7.40984 20.8099C6.38984 20.8099 5.66984 20.2899 5.39984 19.3299C5.34984 19.1499 5.33984 18.9499 5.33984 18.7599C5.33984 16.2599 5.33984 13.7599 5.33984 11.2499C5.33984 10.2099 5.99984 9.46994 6.79984 9.26994C6.99984 9.21994 7.20984 9.18994 7.41984 9.18994C12.4798 9.18994 17.5398 9.18994 22.5998 9.18994C23.8398 9.18994 24.6798 10.0199 24.6798 11.2699C24.6798 13.7599 24.6798 16.2399 24.6798 18.7299C24.6798 19.7499 24.1598 20.4599 23.2198 20.7299C23.0098 20.7899 22.7898 20.8099 22.5798 20.8099C20.0498 20.8099 17.5298 20.8099 14.9998 20.8099H14.9898ZM22.7498 18.8699V11.1399H14.9998V18.8699H22.7498ZM12.0198 17.7799C12.5498 17.7799 12.8198 17.3399 12.6198 16.8799C11.9998 15.4599 11.3698 14.0299 10.7198 12.6199C10.6498 12.4599 10.4498 12.3099 10.2798 12.2499C9.95984 12.1399 9.72984 12.2999 9.55984 12.6799C8.94984 14.0599 8.32984 15.4299 7.71984 16.8099C7.67984 16.8899 7.65984 16.9799 7.63984 17.0599C7.56984 17.3399 7.69984 17.5899 7.95984 17.7199C8.19984 17.8399 8.51984 17.7799 8.66984 17.5499C8.78984 17.3799 8.87984 17.1899 8.95984 16.9999C9.00984 16.8799 9.07984 16.8299 9.20984 16.8399C9.69984 16.8399 10.1998 16.8699 10.6898 16.8399C11.1098 16.8099 11.3998 16.8899 11.4998 17.3399C11.5098 17.3899 11.5498 17.4399 11.5798 17.4899C11.6998 17.6799 11.8598 17.7999 12.0198 17.7899V17.7799Z"
          fill={primaryColor}
        />
        <path
          d="M18.1497 16.24C17.9897 16.1 17.8497 16.01 17.7397 15.9C17.4997 15.64 17.4997 15.33 17.7097 15.1C17.9197 14.87 18.2197 14.83 18.4897 15.03C18.6797 15.17 18.8397 15.34 19.0697 15.54C19.3597 15.1 19.6597 14.66 19.9497 14.22C19.9297 14.19 19.9197 14.17 19.8997 14.14C19.8197 14.14 19.7297 14.14 19.6497 14.14C18.7097 14.14 17.7597 14.14 16.8197 14.14C16.5897 14.14 16.3797 14.1 16.2397 13.91C16.0997 13.72 16.0697 13.51 16.1697 13.3C16.2797 13.07 16.4797 12.97 16.7197 12.97C17.1397 12.97 17.5597 12.97 17.9797 12.97C18.0697 12.97 18.1597 12.97 18.2397 12.97C18.3897 12.44 18.5697 12.25 18.8797 12.25C19.2097 12.25 19.3797 12.44 19.5197 12.97C20.0697 12.97 20.6297 12.95 21.1797 12.97C21.3697 12.97 21.5997 13.04 21.7297 13.16C22.0597 13.47 21.8897 14 21.4497 14.1C21.2797 14.14 21.2097 14.22 21.1497 14.36C20.8697 15.05 20.5097 15.7 19.9897 16.27C20.1897 16.4 20.3797 16.51 20.5597 16.63C20.9097 16.86 21.0097 17.17 20.8397 17.47C20.6597 17.78 20.3197 17.85 19.9497 17.64C19.7097 17.5 19.4797 17.36 19.2497 17.21C19.1197 17.12 19.0297 17.12 18.8897 17.2C18.5397 17.4 18.1697 17.59 17.7897 17.74C17.5297 17.84 17.2597 17.69 17.1497 17.44C17.0297 17.19 17.0897 16.9 17.3297 16.74C17.5697 16.58 17.8297 16.44 18.1497 16.25V16.24Z"
          fill={primaryColor}
        />
        <path
          d="M10.1599 14.3298C10.3399 14.7498 10.5199 15.1398 10.6999 15.5698H9.60986C9.78986 15.1598 9.96986 14.7598 10.1599 14.3298Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_79_2804">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(2.5 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Interests: ({
    primaryColor = "#000",
    secondaryColor = "#fff",
    size = 24,
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill={secondaryColor} />
      <g clip-path="url(#clip0_79_2885)">
        <path
          d="M12.0101 20.6901C12.0101 20.2801 12.0101 19.8701 12.0101 19.4601C12.0101 19.2601 12.0701 19.1101 12.2101 18.9701C13.9101 17.1301 15.6001 15.2901 17.2901 13.4501C17.5901 13.1201 17.5501 12.7301 17.2001 12.5501C17.0001 12.4401 16.7701 12.4901 16.5401 12.7001C15.2901 13.8201 14.0401 14.9301 12.7901 16.0501C12.0101 16.7401 11.2301 17.4401 10.4601 18.1301C10.3501 18.2301 10.2701 18.2501 10.1301 18.1801C9.30011 17.7601 8.46011 17.3501 7.63011 16.9201C7.27011 16.7401 7.02011 16.4701 7.01011 16.0301C7.00011 15.5801 7.21011 15.2701 7.59011 15.0601C12.1901 12.4301 16.7901 9.80012 21.3901 7.17012C21.7601 6.96012 22.1401 6.90012 22.5201 7.15012C22.9001 7.39012 23.0301 7.76012 22.9701 8.19012C22.8701 8.92012 22.7601 9.64012 22.6501 10.3601C22.4101 11.9301 22.1701 13.5001 21.9201 15.0701C21.6801 16.6401 21.4401 18.2101 21.2001 19.7801C21.1401 20.1701 21.0701 20.5701 21.0201 20.9601C20.9101 21.7701 20.2901 22.1401 19.5401 21.8401C18.3901 21.3801 17.2501 20.9101 16.1001 20.4301C15.9201 20.3601 15.8201 20.3901 15.7001 20.5201C15.0701 21.2101 14.4401 21.9001 13.8001 22.5801C13.3201 23.0901 12.6401 23.1101 12.2501 22.6101C12.1101 22.4301 12.0401 22.1601 12.0201 21.9201C11.9801 21.5101 12.0101 21.0901 12.0101 20.6701V20.6901Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_79_2885">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(2.5 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Certifications: ({
    primaryColor = "#000",
    secondaryColor = "#fff",
    size = 24,
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill={secondaryColor} />
      <g clip-path="url(#clip0_79_3139)">
        <path
          d="M11.0302 11.15C11.0102 11.1 10.9902 11.07 10.9902 11.04C11.0102 10.23 10.9902 9.42 11.0702 8.62C11.1402 7.85 11.8502 7.18 12.6202 7.06C12.8602 7.02 13.1002 7 13.3402 7C14.7802 7 16.2302 7 17.6702 7C17.9302 7 17.9902 7.08 17.9902 7.33C17.9802 8.47 17.9702 9.62 17.9902 10.76C17.9902 11.03 18.0402 11.33 18.1602 11.57C18.3502 11.94 18.7302 12.02 19.1302 12.02C20.3102 12.02 21.4802 12.02 22.6602 12.02C23.0002 12.02 23.0002 12.02 23.0002 12.35C23.0002 15.19 23.0002 18.03 23.0002 20.86C23.0002 21.93 22.4502 22.69 21.4902 22.96C21.3102 23.01 21.1102 23.02 20.9202 23.02C18.6602 23.02 16.4002 23.02 14.1302 23.02C14.0702 23.02 14.0202 23.01 13.9902 23.01C13.9902 22.08 13.9902 21.16 13.9902 20.25C13.9902 20.16 14.0602 20.05 14.1402 20C14.6702 19.65 15.0602 19.21 15.1502 18.55C15.1602 18.46 15.2402 18.35 15.3202 18.29C15.9702 17.75 16.1302 17.08 15.8802 16.29C15.8202 16.09 15.8202 15.92 15.8902 15.72C16.1502 15.04 15.8902 14.21 15.3202 13.76C15.2302 13.69 15.1502 13.57 15.1302 13.47C14.9402 12.52 14.4702 12.06 13.4902 11.86C13.3902 11.84 13.2802 11.76 13.2102 11.67C12.6302 11.02 11.9402 10.86 11.1302 11.15C11.1002 11.16 11.0602 11.15 11.0102 11.16L11.0302 11.15Z"
          fill={primaryColor}
        />
        <path
          d="M15.0001 15.1301C14.9301 15.3301 14.8501 15.5401 14.8101 15.7501C14.7801 15.9201 14.8101 16.1001 14.8101 16.2801C14.8101 16.3401 14.8601 16.4001 14.8801 16.4601C15.0601 16.9001 15.0101 17.2401 14.6401 17.5301C14.3401 17.7701 14.1701 18.0301 14.1201 18.4201C14.0501 18.9501 13.8501 19.1101 13.3101 19.1601C13.0401 19.1801 12.9601 19.2901 12.9701 19.5501C12.9801 20.4901 12.9701 21.4401 12.9701 22.3801C12.9701 22.6201 12.9501 22.8501 12.7001 22.9801C12.4601 23.1001 12.2701 22.9801 12.0801 22.8501C11.7701 22.6401 11.4601 22.4201 11.1401 22.2301C11.0701 22.1901 10.9301 22.1801 10.8601 22.2301C10.4901 22.4501 10.1401 22.7101 9.77006 22.9401C9.44006 23.1501 9.11006 23.0101 9.02006 22.6301C8.99006 22.5301 8.99006 22.4201 8.99006 22.3101C8.99006 21.3801 8.98006 20.4601 8.99006 19.5301C8.99006 19.2901 8.93006 19.2001 8.68006 19.1701C8.08006 19.1101 7.94006 18.9501 7.84006 18.3401C7.83006 18.2701 7.84006 18.2001 7.80006 18.1401C7.72006 17.9901 7.65006 17.8401 7.54006 17.7101C7.46006 17.6201 7.34006 17.5601 7.25006 17.4801C7.03006 17.2801 6.95006 17.0201 7.01006 16.7301C7.01006 16.6801 7.03006 16.6301 7.06006 16.5901C7.26006 16.2201 7.24006 15.8701 7.07006 15.4701C6.88006 15.0301 6.98006 14.7301 7.38006 14.4801C7.70006 14.2701 7.81006 14.0101 7.85006 13.6601C7.91006 13.1101 8.14006 12.8901 8.70006 12.8801C8.99006 12.8801 9.20006 12.7701 9.37006 12.5201C9.72006 12.0101 9.95006 11.9301 10.5401 12.1601C10.8601 12.2901 11.1401 12.2601 11.4501 12.1401C11.9701 11.9401 12.2001 12.0001 12.5401 12.4401C12.7601 12.7201 12.9901 12.8901 13.3801 12.8801C13.8101 12.8801 14.0701 13.1401 14.1101 13.6201C14.1401 14.0101 14.2901 14.2701 14.6101 14.4801C14.8301 14.6301 14.9901 14.8301 15.0001 15.1401V15.1301ZM12.9901 16.0601C13.0101 14.9501 12.1501 14.0201 11.0201 14.0301C9.94006 14.0301 9.01006 14.7601 8.99006 16.0001C8.97006 17.1501 9.79006 17.9901 10.9801 18.0101C12.0901 18.0301 12.9601 17.1701 12.9801 16.0601H12.9901Z"
          fill={primaryColor}
        />
        <path
          d="M22.88 10.9599C22.78 10.9699 22.69 10.9899 22.6 10.9899C21.5 10.9899 20.4 10.9899 19.29 10.9899C19.11 10.9899 19.02 10.9599 19.02 10.7399C19.02 9.58988 19.02 8.43988 19.02 7.27988C19.02 7.21988 19.04 7.15988 19.04 7.12988C20.31 8.38988 21.58 9.65988 22.88 10.9499V10.9599Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_79_3139">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(2.5 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Strengths: ({
    primaryColor = "#000",
    secondaryColor = "#fff",
    size = 24,
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill={secondaryColor} />
      <g clip-path="url(#clip0_79_2831)">
        <path
          d="M16.1302 13.59C16.9202 13.98 17.6902 14.01 18.4302 13.55C19.1402 14.9 20.2002 15.3 21.6602 14.75C21.6202 15.2 21.6202 15.62 21.5502 16.02C21.3102 17.32 20.6802 18.4 19.6502 19.24C19.4702 19.38 19.4102 19.54 19.4102 19.76C19.4102 20.74 19.4102 21.72 19.4102 22.7C19.4102 23.16 19.2502 23.54 18.8202 23.75C18.6802 23.82 18.5002 23.86 18.3402 23.86C16.4702 23.86 14.6002 23.86 12.7302 23.86C12.1502 23.86 11.7202 23.48 11.6902 22.89C11.6502 22.07 11.6602 21.24 11.6602 20.42C11.6602 20.16 11.5802 20.01 11.3502 19.87C10.2202 19.22 9.30015 18.36 8.73015 17.17C8.42015 16.52 8.34015 15.83 8.32015 15.12C8.30015 14.54 8.32015 13.97 8.59015 13.44C9.01015 12.63 9.72015 12.26 10.6002 12.23C11.5902 12.2 12.5802 12.22 13.5702 12.23C14.1402 12.23 14.7102 12.63 14.8902 13.13C15.0902 13.67 14.9102 14.28 14.4502 14.68C14.1902 14.9 13.8802 14.97 13.5502 14.97C12.9602 14.97 12.3702 14.97 11.7702 14.97C11.2702 14.97 11.0102 15.3 11.1302 15.71C11.2002 15.92 11.3302 16.08 11.5602 16.09C12.4602 16.11 13.3802 16.21 14.2702 16C15.2502 15.76 15.9902 14.87 16.0902 13.86C16.0902 13.78 16.1102 13.7 16.1302 13.59Z"
          fill={primaryColor}
        />
        <path
          d="M18.3 10.02C18.3 10.59 18.31 11.17 18.3 11.74C18.28 12.29 17.99 12.59 17.37 12.73C16.97 12.82 16.47 12.6 16.28 12.2C16.18 12 16.14 11.76 16.14 11.53C16.13 10.5 16.12 9.48001 16.14 8.45001C16.14 8.06001 16.21 7.67001 16.59 7.44001C17.38 6.95001 18.29 7.42001 18.31 8.35001C18.33 8.90001 18.31 9.46001 18.31 10.01L18.3 10.02Z"
          fill={primaryColor}
        />
        <path
          d="M12.8103 9.0199C12.8103 8.3799 12.7903 7.7399 12.8103 7.1099C12.8303 6.6099 13.1303 6.2799 13.5703 6.1799C14.3003 6.0099 14.9503 6.3899 14.9703 7.2899C14.9803 7.8399 14.9703 8.3799 14.9703 8.9299C14.9703 9.5699 14.9703 10.2099 14.9703 10.8399C14.9703 11.0299 14.9103 11.0999 14.7103 11.0999C14.1503 11.0899 13.5803 11.0999 13.0203 11.0999C12.8403 11.0999 12.7803 11.0299 12.7803 10.8499C12.7803 10.2399 12.7803 9.6299 12.7803 9.0199C12.7803 9.0199 12.7803 9.0199 12.7903 9.0199H12.8103Z"
          fill={primaryColor}
        />
        <path
          d="M21.6703 11.69C21.6403 12.12 21.6303 12.59 21.5803 13.05C21.5303 13.5 21.0703 13.85 20.5603 13.86C20.1003 13.87 19.6103 13.52 19.5203 13.11C19.4803 12.9 19.4403 12.69 19.4503 12.48C19.4503 11.76 19.4503 11.04 19.5003 10.32C19.5303 9.81998 19.9903 9.48998 20.5403 9.47998C21.0903 9.47998 21.5403 9.78998 21.6003 10.29C21.6603 10.74 21.6603 11.19 21.6803 11.69H21.6703Z"
          fill={primaryColor}
        />
        <path
          d="M11.6501 9.62987C11.6501 10.0299 11.6501 10.4299 11.6501 10.8199C11.6501 11.0199 11.6001 11.0999 11.3801 11.0999C10.8301 11.0899 10.2701 11.0899 9.72012 11.0999C9.52012 11.0999 9.44012 11.0299 9.44012 10.8299C9.44012 10.0399 9.42012 9.25987 9.45012 8.46987C9.47012 8.00987 9.57012 7.54987 10.0801 7.35987C10.4801 7.20987 10.8701 7.21987 11.2401 7.47987C11.5701 7.71987 11.6301 8.07987 11.6501 8.43987C11.6701 8.83987 11.6501 9.23987 11.6501 9.62987Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_79_2831">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(2.5 2.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Skills: ({ primaryColor = "#000", secondaryColor = "#fff", size = 24 }) => (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="15" fill={secondaryColor} />
        <g clip-path="url(#clip0_79_2754)">
          <path
            d="M15 19.43C14.16 19.43 13.32 19.43 12.48 19.43C12.31 19.43 12.2 19.4 12.14 19.22C11.7 18 10.95 16.95 10.17 15.93C7.90999 12.96 8.78999 8.69998 12.06 6.87998C12.73 6.50998 13.46 6.27998 14.23 6.17998C17.08 5.81998 19.53 7.40998 20.54 9.74998C21.47 11.91 21.2 13.99 19.83 15.91C19.07 16.97 18.27 17.99 17.83 19.24C17.77 19.4 17.65 19.42 17.5 19.42C16.67 19.42 15.84 19.42 15 19.42V19.43ZM11.66 12.78C11.95 12.78 12.13 12.65 12.19 12.36C12.22 12.22 12.24 12.07 12.26 11.92C12.36 10.82 13.09 9.90998 14.16 9.60998C14.48 9.51998 14.81 9.50998 15.13 9.42998C15.42 9.34998 15.58 9.09998 15.54 8.81998C15.5 8.53998 15.29 8.33998 14.99 8.33998C14.42 8.33998 13.86 8.42998 13.36 8.68998C11.97 9.40998 11.21 10.55 11.09 12.12C11.06 12.51 11.29 12.78 11.66 12.78Z"
            fill={primaryColor}
          />
          <path
            d="M17.7202 20.5999C17.9102 22.1699 17.0902 23.4499 15.5802 23.7899C14.0902 24.1199 12.5002 23.2399 12.2702 21.4999C12.2402 21.2599 12.2402 21.0199 12.2202 20.7799C12.2202 20.6299 12.2702 20.5599 12.4302 20.5599C14.1802 20.5599 15.9302 20.5599 17.6702 20.5599C17.6702 20.5599 17.6902 20.5599 17.7102 20.5899L17.7202 20.5999Z"
            fill={primaryColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_79_2754">
            <rect
              width="25"
              height="25"
              fill="white"
              transform="translate(2.5 2.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
  Home: ({ primaryColor = "#000", secondaryColor = "#fff", size = 24 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={secondaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </svg>
  ),
  Search: ({ primaryColor = "#000", secondaryColor = "#fff", size = 24 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={secondaryColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="10.5" r="7.5" />
      <line
        x1="21"
        y1="21"
        x2="15.8"
        y2="15.8"
        stroke={secondaryColor}
        strokeWidth="2"
      />
    </svg>
  ),
  // Add more SVGs here
};
